if (!customElements.get("sort-dropdown")) {
  customElements.define(
    "sort-dropdown",
    class SortDropdown extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector("[data-sort-select]");
        this.toggle = this.querySelector(".dropdown-toggle");
        this.panel = this.querySelector(".dropdown-list-wrap");
        this.currentLabel = this.querySelector("[data-sort-current]");
        this.options = this.querySelectorAll(".dropdown-list-option");

        this.toggle.addEventListener("click", () => this.toggleOpen());

        this.options.forEach((option) => {
          option.addEventListener("click", (event) => {
            event.preventDefault();
            this.selectValue(option);
          });
        });

        document.addEventListener("click", (event) => {
          if (!this.contains(event.target)) {
            this.close();
          }
        });

        this.addEventListener("keyup", (event) => {
          if (event.code === "Escape") {
            this.close();
            this.toggle.focus();
          }
        });
      }

      isOpen() {
        return this.toggle.getAttribute("aria-expanded") === "true";
      }

      toggleOpen() {
        if (this.isOpen()) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.toggle.setAttribute("aria-expanded", "true");
        this.panel.setAttribute("aria-hidden", "false");
      }

      close() {
        this.toggle.setAttribute("aria-expanded", "false");
        this.panel.setAttribute("aria-hidden", "true");
      }

      selectValue(option) {
        this.select.value = option.dataset.value;
        this.select.dispatchEvent(new Event("input", { bubbles: true }));
        this.currentLabel.textContent = option.dataset.label || "";
        this.options.forEach((item) => item.classList.remove("current"));
        option.classList.add("current");
        this.close();
      }
    },
  );
}
